export default "__VITE_ASSET__DRTIhDml__"